import { useCallback, useEffect, useReducer, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CrudMode } from '@ohpen/enso-ui';
import { IconUsers } from '@tabler/icons-react';

import { useValueListsStore } from '@pmp/stores';
import { ConfirmCrDeleteModal, AdvisersList } from '@pmp/components';
import { FieldType, IntermediaryGetAll } from '@pmp/api';

import { TabContent } from '../../brokers/components/TabContent';
import { CrudFormCard } from './CrudFormCard';
import { TabProps } from '../interfaces';

import { getInitialState, reducer } from '../../lender/reducer';

export const AdvisersTab: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  const { valueLists, getValueLists } = useValueListsStore();
  const [state, dispatch] = useReducer(reducer<any>, getInitialState<any>());
  const { t } = useTranslation();
  const readonly = mode === CrudMode.VIEW;
  const advisers = form?.getFieldValue?.('advisers') as IntermediaryGetAll[];

  useEffect(() => {
    getValueLists({ alwaysFetch: [FieldType.USER_ROLE_TYPE] });
  }, [getValueLists]);

  const onCreate = useCallback(() => {
    dispatch({ type: 'openCrud', record: null, mode: CrudMode.CREATE });
  }, []);

  const onView = useCallback((record: any) => {
    dispatch({ type: 'openCrud', record, mode: CrudMode.VIEW });
  }, []);

  const onEdit = useCallback((record: any) => {
    dispatch({ type: 'openCrud', record, mode: CrudMode.EDIT });
  }, []);

  const onCloseCrud = useCallback(() => {
    dispatch({ type: 'closeCrud' });
  }, []);

  const onDelete = useCallback((record: any) => {
    dispatch({ type: 'openDeleteModal', record });
  }, []);

  const onCloseDeleteModal = useCallback(() => {
    dispatch({ type: 'closeDeleteModal' });
  }, []);

  return (
    <TabContent noScroll>
      <CrudFormCard icon={<IconUsers />} title={t('lender.brokers.labels.advisers')}>
        <AdvisersList
          data={advisers ?? []}
          isFetching={false}
          valueLists={valueLists}
          readonly={readonly}
          onCreate={onCreate}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        {/* {state.crud.open && state.crud.mode && (
          <AdvistersCrudForm
            mode={state.crud.mode}
            valueLists={valueLists}
            initialValues={initialValues}
            refreshTable={refreshTable}
            onClose={onCloseCrud}
          />
        )} */}
        {/* <ConfirmCrDeleteModal
          open={state.deleteModal.open}
          records={state.deleteModal.record ? [state.deleteModal.record] : []}
          idKey="id"
          nameKey="id"
          entityLabel={t('lender.procurationFees.labels.procurationFee')}
          entityLabelPlural={t('lender.procurationFees.labels.procurationFees')}
          firmId={firmId}
          getFirmPrecheck={firmProcFeeAssignmentsValidateDelete}
          createFirmDeleteChangeRequest={firmProcFeeAssignmentsCreateDeleteCr}
          refreshTable={refreshTable}
          onClose={onCloseDeleteModal}
        /> */}
      </CrudFormCard>
    </TabContent>
  );
};
